import LegacyVideoConferenceComponent from 'src/components/pages/pageElements/videoConference/LegacyVideoConference';
import VideoConference from 'src/components/pages/pageElements/videoConference/VideoConference';
import withScripts from 'src/util/withScripts';

const withOpenTokScripts = withScripts('https://static.opentok.com/v2/js/opentok.min.js');

export const LegacyVideoConference = withOpenTokScripts(LegacyVideoConferenceComponent);

export default withOpenTokScripts(VideoConference);
